import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/rpa-banner.png";
import overlayimg from "./../../assets/images/resource/uipath.jpg";

const AI_RPA_Strategy = () => {
  pageTitle("AI & RPA Strategy");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div className="ai-overlay-wrapper">
        <img src={aiAccounting} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          {/* Left corner image */}
          <img
            src={overlayimg}
            alt="RPA Icon"
            className="ai-overlay-corner-img"
          />

          {/* Centered text */}
          <div className="ai-overlay-center-text">
            <h2>RPA STRATEGY</h2>
            <p>Identify, Assess, and Automate</p>
          </div>
        </div>
      </div>

      <section class="siw-rpa-section">
        <div class="siw-rpa-container container">
          <div class="siw-rpa-content">
            <span class="siw-rpa-tag">
              Your trusted automation strategy partner
            </span>

            <div class="siw-rpa-text">
              <p>
                Are your business processes fully aligned with your
                organizational objectives? If not, how are those processes
                currently executed? Automation is a critical pillar of digital
                transformation, enabling organizations to modernize and optimize
                back-end operations through intelligent automation to remain
                competitive. Through a structured RPA strategy, we assess,
                identify, and prioritize processes best suited for automation.
              </p>
            </div>

            <p class="siw-rpa-desc">
              <span className="SiW">SiW</span> leads with educational workshops,
              stakeholder interviews, and technical assessments to uncover
              high-value automation opportunities. By partnering with SiW,
              organizations benefit from proven best practices to design and
              implement a robust RPA strategy that drives adoption, sustains
              continuous improvement, and delivers long-term automation
              success-creating measurable and lasting business impact.
            </p>
          </div>

          <div class="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>
              Let’s Build Your Intelligent Automation
            </h4>
            <p>
              <span style={{fontSize:"20px" , fontWeight:"bold"}}>SiW</span> uses a proven assessment approach
              to identify the right automation opportunities and develop a clear
              RPA roadmap aligned with your business goals. Our strategy focuses
              on delivering measurable value, improving efficiency, and driving
              sustainable growth.
            </p>
            <h4>
              Call us at{" "}
              <a href="tel:+6590059743" style={{ color: "rgb(230, 233, 55)" }}>
                +65 9005 9743
              </a>{" "}
              <br></br>
              to discuss your RPA strategy
            </h4>
            <a href="/contact" class="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Schedule a Meeting
            </a>
          </div>
        </div>
      </section>

      <section className="siw-approach">
        <div className="siw-approach-container container">
          {/* Header */}
          <span className="siw-approach-label">OUR APPROACH</span>
          <h2 className="siw-approach-title">RPA Strategy Methodology</h2>

          <p className="siw-approach-desc">
            We leverage a proven assessment model to define automation
            deployment and create an RPA roadmap aligned with your business
            strategy and outcomes.
          </p>

          {/* Steps */}
          <div className="siw-approach-steps">
            <div className="siw-step">
              <span className="siw-step-no">01</span>
              <div>
                <h4>Discover</h4>
                <p>
                  Identify RPA opportunities to drive efficiencies and
                  productivity
                </p>
              </div>
            </div>

            <div className="siw-step">
              <span className="siw-step-no">02</span>
              <div>
                <h4>Assess</h4>
                <p>
                  Assess current state and identify automation gaps in business
                  and IT
                </p>
              </div>
            </div>

            <div className="siw-step">
              <span className="siw-step-no">03</span>
              <div>
                <h4>Define Future</h4>
                <p>Develop RPA strategies to define the future state</p>
              </div>
            </div>

            <div className="siw-step">
              <span className="siw-step-no">04</span>
              <div>
                <h4>Prioritize</h4>
                <p>
                  Create opportunity prioritization using cost-benefit analysis
                </p>
              </div>
            </div>

            <div className="siw-step">
              <span className="siw-step-no">05</span>
              <div>
                <h4>Roadmap</h4>
                <p>Design opportunity roadmap based on prioritization</p>
              </div>
            </div>

            <div className="siw-step">
              <span className="siw-step-no">06</span>
              <div>
                <h4>Execute</h4>
                <p>Implement RPA strategy and deploy automations</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};

export default AI_RPA_Strategy;
